module.exports = __webpack_public_path__ + "media/images/lp/1/plight2-sp-1784831019af73ffab587cf61248e1fd.png";